module.exports = __webpack_public_path__ + "img/BANNER_TITLE.8d3f3b40.png";